


























































































import { Result } from '@empathybroker/tsclient-search';

import { Location, Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import {
  ExplainHeader,
  ExplainResultOverlay,
  ExplainResultsAside,
  ExplainResultsScoreHistogram,
  IntersectElement,
  ResultsGrid,
  UiIconButton
} from '../../components';

import { ApiEnum, DeviceEnum, FilterTypeEnum } from '../../enums';

import { Dictionary, Filter, GuardResolveFunction, RegularFilter, RegularFilterConfig, RegularFilterSelectedValues } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';
import { SEARCH_CONSTS } from '../../store/search/search.consts';

import { ExplainUtils } from '../../utils';

export default {
  name: 'explain',
  components: {
    ExplainHeader,
    ExplainResultsScoreHistogram,
    UiIconButton,
    ResultsGrid,
    ExplainResultOverlay,
    IntersectElement,
    ExplainResultsAside
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    filters: function (): RegularFilter[] {
      return (Object.values(this.context.filters).reduce((filters: RegularFilter[], filter: Filter) => {
        if (filter.config.type === FilterTypeEnum.REGULAR) {
          const filterConfig = (filter.config as RegularFilterConfig);
          const filterSelectedValues = (filter.selectedValues as RegularFilterSelectedValues);
          filters.push({
            config: {
              ...filterConfig,
              mandatory: true,
              multiselectDisabled: true
            },
            selectedValues: ((!filterSelectedValues.length && (filterConfig.values.length === 1)) ? [filterConfig.values[0].id]
              : filterSelectedValues.slice(0, 1))
          });
        }
        return filters;
      }, []) as RegularFilter[]);
    },
    isSearchRequestEnabled: function (): boolean {
      return (
        !this.loading &&
        !!this.context.query &&
        this.filters.every((filter: RegularFilter) => (
          !filter.config.mandatory ||
          !!filter.selectedValues.length
        ))
      );
    },
    resultsWithGroupedScore: function (): Result[] {
      return this.results.items.map(ExplainUtils.getResultWithGroupedScore);
    },
    selectedResultsWithGroupedScore: function (): Result[] {
      return this.resultsWithGroupedScore.filter((result: Result) => (this.selectedResultIds.includes(result.id)));
    },
    histogramResults: function (): Result[] {
      return this.resultsWithGroupedScore.slice(0, this.histogramMaxResultsCount);
    },
    histogramMaxResultsCount: function (): number {
      if (this.$epb.device <= DeviceEnum.SMALL_TABLET) {
        return 12;
      }
      return 24;
    },
    resultsPerRow: function (): number {
      if (this.$epb.device <= DeviceEnum.MOBILE) {
        return 1;
      } else if (this.$epb.device <= DeviceEnum.TABLET) {
        return 2;
      }
      return 4;
    },
    allPagesLoaded: function (): boolean {
      return (!this.loading && (this.results.items.length >= this.results.total));
    }
  },
  data: function () {
    return {
      results: {
        items: [],
        total: 0
      },
      pagination: {
        page: 1,
        itemsPerPage: 24
      },
      loading: false,
      selectedResultIds: [],
      histogramCollapsed: false,
      histogramDetailed: false,
      asideCollapsed: false,
      contextWatchDisabled: false,
      messages: this.$epb.messages.explain
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setFiltersSelectedValues: CONTEXT_CONSTS.actions.setFiltersSelectedValues,
      setQuery: CONTEXT_CONSTS.actions.setQuery
    }),
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search
    }),
    onFiltersSelectedValuesChange: async function (payload: Dictionary<RegularFilterSelectedValues>): Promise<void> {
      await this.setFiltersSelectedValues(payload);
      this.$emit('contextChanged');
    },
    onQueryChange: async function (query: string): Promise<void> {
      await this.setQuery(query);
      this.$emit('contextChanged');
    },
    loadPage: async function (page = 1): Promise<void> {
      if (this.isSearchRequestEnabled) {
        this.loading = true;
        this.pagination.page = page;
        if (page === 1) {
          this.results = {
            items: [],
            total: 0
          };
        }
        try {
          const searchResponse = await this.search({
            filters: this.filters,
            pagination: this.pagination,
            query: this.context.query,
            debugEnabled: true
          });
          this.results = {
            items: this.results.items.concat(searchResponse.data.items),
            total: searchResponse.data.total
          };
        } catch (error) {
          this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.SEARCH));
        } finally {
          this.loading = false;
        }
      }
    },
    onResultClick: function (resultId: string): void {
      if (!this.selectedResultIds.includes(resultId)) {
        this.selectedResultIds.push(resultId);
      } else {
        this.selectedResultIds.splice(this.selectedResultIds.indexOf(resultId), 1);
      }
    },
    removeSelectedResults: function (resultIds: string[]): void {
      this.selectedResultIds = this.selectedResultIds.filter((resultId: string) => !resultIds.includes(resultId));
    }
  },
  mounted: async function (): Promise<void> {
    await this.loadPage();
  },
  beforeRouteLeave: async function (to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    this.contextWatchDisabled = true;
    let redirectLocation: Location;
    if (!!this.context.query) {
      await this.setQuery(undefined);
      redirectLocation = {
        ...to,
        query: {
          ...to.query,
          [ROUTER_CONSTS.query.query]: undefined
        }
      };
    }
    next(redirectLocation);
  },
  watch: {
    context: {
      handler: async function (): Promise<void> {
        if (!this.contextWatchDisabled) {
          this.selectedResultIds = [];
          this.histogramCollapsed = false;
          await this.loadPage();
        }
      },
      deep: true
    }
  }
};

